<form [formGroup]="formTable" class="row" (ngSubmit)="addData()">
  <div class="col-12">
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>Observación</mat-label>
      <textarea
        matInput
        placeholder="Observaciones y seguimiento de respuesta de la aseguradora y reposicion de daños..."
        formControlName="observacion"
      ></textarea>
    </mat-form-field>
  </div>
  <div class="col-6">
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>Fecha</mat-label>
      <input
        matInput
        placeholder="Fecha en que se envio la comunicación"
        formControlName="fecha"
        [matDatepicker]="picker3"
      />
      <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
      <mat-datepicker #picker3></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="col-6 padding">
    <div>
      <button
        class="button"
        *ngIf="!status"
        type="submit"
        [disabled]="formTable.invalid || submit"
      >
        Agregar Observación
      </button>
    </div>
  </div>
</form>

<div class="task_content_table">
  <table mat-table #dataTable [dataSource]="dataSource" class="task_table">
    <ng-container matColumnDef="fecha">
      <th class="header-options" mat-header-cell *matHeaderCellDef>Fecha</th>
      <td mat-cell *matCellDef="let element">
        {{ element.fecha | date : "d/M/yy" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="observacion">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Observación
      </th>
      <td mat-cell *matCellDef="let element">{{ element.observacion }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<mat-paginator
  [pageSizeOptions]="[5, 10, 25, 50, 100]"
  [pageSize]="5"
  [showFirstLastButtons]
></mat-paginator>
